export default __webpack_public_path__ + "static/media/kafka.6d3c3af6.svg";